import script from "./LoadingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingView.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingView.vue?vue&type=style&index=0&id=acb18258&scoped=true&lang=css"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acb18258"]])

export default __exports__